import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";

const TermsAndConditions = () => {
  return (
    <Box
      sx={{
        p: 4,
        backgroundColor: "#f5f5f5",
        display: "flex",    
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
        <Box
          sx={{
            position: "relative",
            // height: "300px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            // marginBlock:'0.8rem',
            padding: 2,
            marginBlock:'2rem',
            backgroundColor: "white",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            borderRadius: "16px",
            maxWidth:800
          }}
        >
    
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
        Terms and Conditions
      </Typography>
      <Typography variant="body1" gutterBottom>
        Welcome to Aastha computers! By enrolling in our courses, you agree to
        the following terms and conditions. Please read them carefully.
      </Typography>

      <List>
        <ListItem>
          <ListItemText
            primary="1. Enrollment and Fees"
            secondary="Enrollment in our courses requires complete payment of fees before the start of the course. Fees once paid are non-refundable except in special cases determined at our discretion."
          />
        </ListItem>

        <ListItem>
          <ListItemText
            primary="2. Attendance and Conduct"
            secondary="Regular attendance and respectful conduct are mandatory. A minimum attendance level is required to qualify for course completion certificates."
          />
        </ListItem>

        <ListItem>
          <ListItemText
            primary="3. Intellectual Property"
            secondary="All course materials are the intellectual property of Aastha computers and cannot be reproduced, distributed, or sold without permission."
          />
        </ListItem>

        <ListItem>
          <ListItemText
            primary="4. Liability"
            secondary="We strive to provide high-quality training, but we are not liable for any loss, damage, or consequences arising from the use or inability to use the knowledge obtained in our courses."
          />
        </ListItem>
      </List>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, fontWeight: "bold" }}>
        How We Use Data
      </Typography>
      <Typography variant="body1">
        At Aastha computers, we prioritize the privacy and security of our students' data. We collect and use data solely to:
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="1. Improve Course Quality" secondary="Your feedback and performance data help us refine our training methods and content." />
        </ListItem>
        <ListItem>
          <ListItemText primary="2. Communication and Support" secondary="We use your contact details to provide course updates, assignments, and student support." />
        </ListItem>
        <ListItem>
          <ListItemText primary="3. Marketing" secondary="With your consent, we may use your data to inform you of new courses, events, and offers relevant to you." />
        </ListItem>
      </List>

      <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
        Rest assured, we will never sell or share your data with third parties.
        By continuing with enrollment, you consent to these terms.
      </Typography>
      </Box>
    </Box>
  );
};

export default TermsAndConditions;
